"use strict";

var _regeneratorRuntime = require("/media/konapun/Data/Programming/projects/konapun.github.io/node_modules/@babel/runtime/regenerator");

require("regenerator-runtime/runtime.js");

var _asyncToGenerator = require("/media/konapun/Data/Programming/projects/konapun.github.io/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("source-map-support/register");

var _error = require("../error");

var signals = {
  SIGINT: 1,
  // polite interrupt
  SIGSTP: 2,
  // pause
  SIGRES: 3 // resume

};
var registry = {};

var signal = function signal() {
  return function (_ref) {
    var environmentService = _ref.environmentService,
        jobService = _ref.jobService,
        userService = _ref.userService,
        permissionService = _ref.permissionService;
    return {
      signal: signals,
      send: function send(jobId, signal) {
        return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          var _registry$pid, _yield$userService$ge, senderId, _yield$jobService$fin, command, consumerId, pid;

          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (Object.values(signals).includes(signal)) {
                    _context.next = 2;
                    break;
                  }

                  throw new _error.ValidationError("Error sending signal ".concat(signal, " to job ID ").concat(jobId, ": Unknown signal"));

                case 2:
                  _context.next = 4;
                  return userService.getCurrentUser();

                case 4:
                  _yield$userService$ge = _context.sent;
                  senderId = _yield$userService$ge.id;
                  _context.next = 8;
                  return jobService.findOne({
                    id: jobId
                  });

                case 8:
                  _yield$jobService$fin = _context.sent;
                  command = _yield$jobService$fin.command;
                  consumerId = _yield$jobService$fin.userId;

                  if (!(senderId !== consumerId && !permissionService.isSuperuser(senderId))) {
                    _context.next = 13;
                    break;
                  }

                  throw new _error.PermissionError('Cannot send signal to job owned by another user');

                case 13:
                  pid = command.pid;

                  if (!((_registry$pid = registry[pid]) === null || _registry$pid === void 0 ? void 0 : _registry$pid[signal])) {
                    _context.next = 18;
                    break;
                  }

                  registry[pid][signal]();
                  _context.next = 19;
                  break;

                case 18:
                  throw new _error.SearchError("Job with ID ".concat(pid, " does not exist, is not running, or does not specify a signal handler for signal ").concat(signal));

                case 19:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }))();
      },
      createSignalHandler: function createSignalHandler() {
        return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
          var pid, job;
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  pid = environmentService.get('!');
                  registry[pid] = {};
                  _context2.next = 4;
                  return jobService.findOne({
                    'command.pid': pid
                  });

                case 4:
                  job = _context2.sent;
                  jobService.subscribe(job.id, function (job) {
                    if ([jobService.status.FULFILLED, jobService.status.REJECTED].includes(job.status)) {
                      delete registry[pid];
                    }
                  });
                  return _context2.abrupt("return", {
                    onSignal: function onSignal(signal, handler) {
                      if (!Object.values(signals).includes(signal)) {
                        throw new _error.ValidationError("Error installing handler for signal ".concat(signal, ": Unknown signal"));
                      }

                      registry[pid][signal] = handler;
                    }
                  });

                case 7:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }))();
      }
    };
  };
};

var _default = signal;
exports.default = _default;